import { useState } from 'react'
import { formatMoneyValue } from '@/app/utils/formatMoneyValue'
import useLinkDetailsController from './useLinkDetailsController'
import { LinkChart } from './components/LinkChart'
import { TransactionsList } from './components/TransactionsList'
import QRCodeModal from '../components/QRCodeModal'
import { ArrowRight } from 'lucide-react'

const LinkDetails = () => {
  const [isQRCodeModalOpen, setIsQRCodeModalOpen] = useState(false)
  
  const {
    linkData,
    simulations,
    chartData,
    totalAccesses,
    allTransactions,
    contracts,
    totalValue,
    isLoading,
    isLoadingTransactions,
    getPageIndex,
    getPageCount,
    handleNextPage,
    handlePreviousPage,
  } = useLinkDetailsController()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Carregando...</div>
      </div>
    )
  }

  return (
    <div className="min-h-screen p-4">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
        <div className="bg-white02 rounded-lg p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold flex items-end text-gray-800 gap-2">
              <i className="fa-solid fa-chart-simple text-primary text-2xl"></i> Acessos
            </h3>
            <div className="flex items-center gap-2 text-right">
              <p className="text-sm text-black01">Total:</p>
              <p className="text-xl font-bold text-primary">{totalAccesses}</p>
            </div>
          </div>
          
          <LinkChart data={chartData} isLoading={false} />
        </div>

        <div>
          <button 
            onClick={() => setIsQRCodeModalOpen(true)}
            className="w-full h-12 mb-6 px-4 py-2 border border-primary bg-white02 text-primary rounded-lg hover:bg-white02 flex items-center justify-between gap-2 font-medium"
          >
            <div className='flex items-center gap-2'>
                <i className="fa-solid fa-qrcode text-primary text-2xl"></i>
                Compartilhar link
            </div>
            <ArrowRight className='text-primary' />
          </button>
          
          <div className="space-y-4">
            <div className="bg-white02 rounded-lg p-4">
              <p className="text-black01 text-sm mb-1">Simulações</p>
              <p className="text-2xl font-semibold text-gray-900">{simulations}</p>
            </div>
            <div className="bg-white02 rounded-lg p-4">
              <p className="text-black01 text-sm mb-1">Contratações</p>
              <p className="text-2xl font-semibold text-gray-900">{contracts}</p>
            </div>
            <div className="bg-white02 rounded-lg p-4">
              <p className="text-black01 text-sm mb-1">Valor total</p>
              <p className="text-2xl font-semibold text-black01">
                {formatMoneyValue(totalValue)}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div>
        <TransactionsList 
          transactions={allTransactions} 
          isLoading={isLoadingTransactions}
          getPageCount={getPageCount}
          getPageIndex={getPageIndex}
          handleNextPage={handleNextPage}
          handlePreviousPage={handlePreviousPage}
        />
      </div>

      <QRCodeModal
        isOpen={isQRCodeModalOpen}
        onClose={() => setIsQRCodeModalOpen(false)}
        linkName={linkData?.name || ''}
      />
    </div>
  )
}

export default LinkDetails